import { useTheme } from "../../contexts/ThemeContext";
import { useLayoutEffect } from "react";

export default function DefaultDarkModeHOC({ children }) {
	const { toggleTheme } = useTheme();

	useLayoutEffect(() => {
		toggleTheme('dark');
	}, [toggleTheme]);

	return <>{children}</>;
}
